export const UPDATE_PRICING_FORM_USER = "UPDATE_PRICING_FORM_USER";
export const UPDATE_PRICING_FORM_FROM = "UPDATE_PRICING_FORM_FROM";
export const UPDATE_PRICING_FORM_PRICE = "UPDATE_PRICING_FORM_PRICE";
export const UPDATE_MANAGEMENT_FILTER_DEFAULT = "UPDATE_MANAGEMENT_FILTER_DEFAULT";
export const PRICING_FORM_SUBMIT = "PRICING_FORM_SUBMIT";
export const PRICING_FORM_SUBMIT_SUCCESS = "PRICING_FORM_SUBMIT_SUCCESS";
export const PRICING_GET_USER_LIST = "PRICING_GET_USER_LIST";
export const PRICING_GET_USER_LIST_SUCCESS = "PRICING_GET_USER_LIST_SUCCESS";